module.exports = __webpack_public_path__ + "img/paypal-logo.fa90774c.svg";